import React, { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { Box, Container, Typography } from '@material-ui/core'
import { GoogleOAuthProvider } from '@react-oauth/google'

import {
  Form as LoginForm,
  GoogleSignInButton,
  MicrosoftSignInButton,
  LoginSSOForm,
  SSOButton,
} from './components'
import { Page, Divider } from 'components'

import useSnackbar from 'hooks/useSnackbar'

import helpers from 'helpers'

import useStyles from './styles'
import { getGoogleAuthenticationToken } from 'service/env'

const Login = () => {
  const [SSOLogin, setSSOLogin] = useState(false)

  const classes = useStyles()
  const location = useLocation()
  const snackbar = useSnackbar()
  const { slug } = useParams()

  const query = new URLSearchParams(location.search)
  const redirectTo = query.get('redirect_to')
  const companyId = query.get('company_id')

  const locationState = location.state
  const message = locationState
    ? locationState.error || locationState.success
    : ''

  useEffect(() => {
    if (locationState) {
      if (locationState.error) {
        snackbar.open({ message: message, variant: 'error' })
      } else {
        snackbar.open({ message: message, variant: 'success' })
      }
    }
    // eslint-disable-next-line
  }, [message, locationState])

  useEffect(() => {
    if (redirectTo && companyId) {
      sessionStorage.setItem('redirectTo', redirectTo)
      sessionStorage.setItem('companyId', companyId)
    }
  }, [redirectTo, companyId])

  useEffect(() => {
    helpers.whiteLabel.persistSlug(slug)
  }, [slug])

  return (
    <Page
      className={classes.root}
      title="App DPOnet - Acesse a plataforma - LGPD e gestão de dados"
    >
      <Container maxWidth="sm">
        <Typography
          variant="h3"
          color="textPrimary"
          className={classes.welcomeText}
        >
          Bem-vindo(a)!
        </Typography>
        <Box mt={3}>{SSOLogin ? <LoginSSOForm /> : <LoginForm />}</Box>
        <Box mt={3}>
          <Divider>
            <Typography variant="caption" color="textSecondary">
              ou
            </Typography>
          </Divider>
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          className={classes.boxButtonsSocial}
        >
          <Box mt={3} display="flex" justifyContent="center">
            <GoogleOAuthProvider clientId={getGoogleAuthenticationToken()}>
              <GoogleSignInButton />
            </GoogleOAuthProvider>
          </Box>
          <Box mt={3} display="flex" justifyContent="center">
            <MicrosoftSignInButton />
          </Box>
          <Box mt={3} display="flex" justifyContent="center">
            <SSOButton SSOLogin={SSOLogin} setSSOLogin={setSSOLogin} />
          </Box>
        </Box>
      </Container>
    </Page>
  )
}

export default Login
